import BackLayoutMain from "../components/backLayout/main";
import ModuleEmptyPage from "../components/emptyPage";

import BackChangePassword from "../page/back/password";

import BackMemberList from "../page/back/member";
import BackMemberProfile from "../page/back/member/profile";
import BackMemberDetail from "../page/back/member/detail";
import BackKnowledgeList from "../page/back/knowledge";
import BackKnowledgeDetail from "../page/back/knowledge/detail";
import BackQaList from "../page/back/qa";
import BackQaDetail from "../page/back/qa/detail";
import BackContractList from "../page/back/contract";
import BackContractDetail from "../page/back/contract/detail";
import BackRecordList from "../page/back/record";

const routes = [
  {
    path: "back",
    element: <BackLayoutMain />,
    children: [
      {
        path: "password",
        element: <BackChangePassword />,
      },

      {
        path: "member",
        element: <BackMemberList />,
      },
      {
        path: "member/profile/:detailid",
        element: <BackMemberProfile />,
      },
      {
        path: "member/:category/:module/:detailid",
        element: <BackMemberDetail />,
      },

      {
        path: "knowledge",
        element: <BackKnowledgeList />,
      },
      {
        path: "knowledge/:detailid",
        element: <BackKnowledgeDetail />,
      },

      {
        path: "qa",
        element: <BackQaList />,
      },
      {
        path: "qa/:detailid",
        element: <BackQaDetail />,
      },

      {
        path: "contract",
        element: <BackContractList />,
      },
      {
        path: "contract/:detailid",
        element: <BackContractDetail />,
      },

      {
        path: "record",
        element: <BackRecordList />,
      },

      {
        path: "*",
        element: <ModuleEmptyPage />,
      },
    ],
  },
];

export default {
  routes,
};
